import posthog from 'posthog-js';

/**
 * Initialise PostHog pour le suivi des événements.
 * Cette fonction ne doit être appelée qu'après le consentement de l'utilisateur.
 */
export const initPostHog = () => {
  // S'assure que nous sommes dans un navigateur et que PostHog n'est pas déjà chargé.
  if (typeof window !== 'undefined' && !posthog.__loaded) {
    posthog.init('phc_dkyqg40OhlTF2f5JqCL2BY7eXnCo40U1nGq1al3spBZ', {
      api_host: 'https://us.i.posthog.com',
      
      // Capture automatiquement les pages vues, les clics et les interactions.
      autocapture: true, 
      
      // Assure que les événements ne sont envoyés qu'après le consentement.
      opt_in_site_persistence: true, 
      
      // Charge les informations de session et de persistance uniquement après l'initialisation.
      loaded: (posthog) => {
        // Vous pouvez commencer à envoyer des événements personnalisés ici si nécessaire.
      }
    });
  }
};

// Exporte l'instance pour une utilisation ultérieure (ex: événements personnalisés)
export default posthog;